<div id="ai-response-container" [ngClass]="{'editor-view' : editorView}">
  <div class="response-header">
    <h2 class="prompt-description truncate"
        matTooltip="AI generated response for: {{selectedPromptProfile.displayName}} - Prompt action: {{selectedPromptProfile.action}}" matTooltipShowDelay="500">
      <span>
        <!--todo Format css-->
        <mat-icon fontIcon="format_quote" class="quote-start"></mat-icon>
          AI generated response for: {{selectedPromptProfile.displayName}}
        <mat-icon fontIcon="format_quote"  class="quote-end"></mat-icon>
      </span>
    </h2>
    @if (!editorView) {
      <aside class="info-buttons">
        <mat-icon fontIcon="generating_tokens" id="token-count" tabindex="0" matTooltipShowDelay="500" [matTooltip]="this.aiTokenResponse"
                  class="material-icons-outlined"></mat-icon>
      </aside>
      <aside class="small-button-group">
        <button theme="small" id="edit-result" (click)="showEditor()"
                (keydown.enter)="showEditor()" (keydown.space)="showEditor()"
                matTooltipShowDelay="500" [matTooltip]="clientConfig?.enableAiEditorPlugin ? 'Open in an editor (with AI)' : 'Open in an editor'">
          <mat-icon fontIcon="edit" class="watermark"></mat-icon>
          <mat-icon fontIcon="edit"></mat-icon>
          <span>Edit{{clientConfig?.enableAiEditorPlugin ? ' (with AI)' : ''}}</span>
        </button>
        <button theme="small" id="regenerate" (click)="sendAiOptions()"
                (keydown.enter)="sendAiOptions()" (keydown.space)="sendAiOptions()"
                matTooltipShowDelay="500" matTooltip="Run the prompt again for a different result">
          <mat-icon fontIcon="auto_awesome" class="watermark"></mat-icon>
          <mat-icon fontIcon="auto_awesome"></mat-icon>
          <span>Regenerate</span>
        </button>
      </aside>
    }
  </div>
  @if (editorView) {
    <mat-icon fontIcon="close" class="close-full-view" matTooltip="Close the editor view" matTooltipShowDelay="500" (click)="closeEditorView()"></mat-icon>
  }

  <!-- Result Containers (HTML/Text) -->
  <div class="result-container" (mousedown)="checkIfUserIsSelectingText()" (mouseup)="showEditor($event.button)" (dblclick)="responseToClipboard()"
       [matTooltip]="clientConfig?.enableAiEditorPlugin ? 'Click to open in a full editor (with AI)' : 'Click to open in a full editor'" matTooltipShowDelay="500"
       [matTooltipDisabled]="responseTooltipDisabled"
       (mouseenter)="showResponseTooltip()" (mouseleave)="hideResponseTooltip()">
    @if (isHTMLResponse) {
      <article class="html-response scrollable-container"
               [innerHTML]="this.aiResponse"></article>
    }
    @if (!isHTMLResponse) {
      <textarea rows="15" class="text-response scrollable-container">{{this.aiResponse}}</textarea>
    }
  </div>
  <editor id="result"
          apiKey="{{ tinyApiKey }}"
          [init]="{ menubar: false,
                    toolbar: isHTMLResponse,
                    toolbar_mode: 'wrap',
                    plugins: editorPlugins,
                    max_height: 377,
                    ai_request: aiRequestHandler.bind(this),
                    ai_shortcuts: aiShortcuts,
                    setup: setupEditor.bind(this),
                    language: 'en',
                    language_url: translateAIAssistantText()}"
          [toolbar]=toolbar
          [modelEvents]="'change input nodechange undo redo'"
          (ngModelChange)="editorChanged($event)"
          [inline]="false"
          [ngModel]="this.aiResponse"
          [outputFormat]="isHTMLResponse ? 'html' : 'text'"
  ></editor>
</div>

<section class="footer-buttons">
  @if (enableCopyButton) {
    <button theme="medium" id="copyToClipboard" [cdkCopyToClipboard]="aiResponse" (click)="copyToClipboard()"
            matTooltip="Copy to clipboard" matTooltipShowDelay="500">
      <mat-icon fontIcon="content_copy"></mat-icon>
      <span>Copy</span>
    </button>
  }
  @if (fieldNameToSaveTo && activeEntity !== BullhornEntityType.JOB_SUBMISSION) {
    <button theme="medium" id="saveToField" (click)="saveResult(selectedPromptProfile, aiResponse)"
            matTooltipShowDelay="500" [matTooltip]="'Save to field as specified in Prompt Profile'">
      <i class="bhi-field-add"></i>
      <span>Save to Field</span>
    </button>
  }
  @if (activeEntity !== BullhornEntityType.CLIENT_CORPORATION && enableSaveAsNote) {
    <button theme="medium" id="saveToNote" (click)="createBullhornNote(aiResponse)"
            matTooltipShowDelay="500" [matTooltip]="'Save the result as a Note on the record'">
      <i class="bhi-notes"></i>
      <span>Save as Note</span>
    </button>
  }
  <button theme="medium"
          id="emailFromBullhorn"
          (click)="sendBullhornEmail(aiResponse)"
          matTooltipShowDelay="500"
          [matTooltip]="'Send the result as an email'">
    <i class="bhi-email"></i>
    <span>From Bullhorn</span>
  </button>
  @if (activeEntity !== BullhornEntityType.LEAD && selectedPromptProfile?.fileConfig?.enabled) {
    <button theme="medium" id="saveToDocx" (click)="createWordDocx(aiResponse)"
            matTooltipShowDelay="500" [matTooltip]="'Save the result as a Word document on the record'" [disabled]="saveAsDocxButtonDisabled">
      <aside><span class="file-type docx"><span>docx</span></span></aside>
      <span>Save as Docx</span>
    </button>
  }
</section>
